// extracted by mini-css-extract-plugin
module.exports = {"InMemoriamLandingPageContent":"InMemoriamLandingPageContent-module--InMemoriamLandingPageContent--2p6nC","blurb":"InMemoriamLandingPageContent-module--blurb--3TYLz"};